import { render } from "./CheckoutCancel.vue?vue&type=template&id=b16ad2a2"
import script from "./CheckoutCancel.vue?vue&type=script&lang=js"
export * from "./CheckoutCancel.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__